import { StaticActionHandler } from '../elements/TransactionsTableStaticActions/actionHandlers'

export const withAnalyticsTracking = <T extends StaticActionHandler>(
  handler: T,
  list: string,
  button: string,
): StaticActionHandler => {
  return (props) => {
    props.track('xxx - bookkeeping - QuickAction Clicked', {
      list,
      button,
    })
    handler(props)
  }
}
